import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import styled from 'styled-components'
import { Spinner } from '@geist-ui/react'

const OuterDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Title = styled.div`
  color: white;
  font-size: 48px;
  font-weight: 500;
  text-align: center;
  padding: 25px;
  padding-bottom: 0;
`

const Description = styled.div`
  padding: 5px 25px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 50px;
`

const BigSpinner = styled(Spinner)`
  min-width: 100px;
  min-height: 100px;
`

const BACKDROP_PROPS = {
  style: {
    backdropFilter: 'blur(20px)',
  },
}

type SpinnerDialogProps = {
  title: string | null
  description: string | null
  onClose: () => void
}

const SpinnerDialog = ({ title, description, onClose }: SpinnerDialogProps): JSX.Element => {
  const fullscreen = useMediaQuery('(max-width: 43em)')
  const isTablet = useMediaQuery('(max-width: 62em)')

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="sign-in-dialog"
      open={!!title}
      fullScreen={fullscreen}
      PaperProps={{
        style: {
          backgroundColor: '#101010',
          borderRadius: fullscreen ? 0 : 30,
          minWidth: isTablet ? '75vw' : '75vh',
          minHeight: isTablet ? '75vw' : '75vh',
          height: !fullscreen ? (isTablet ? '75vw' : '75vh') : '',
        },
      }}
      BackdropProps={BACKDROP_PROPS}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <OuterDiv>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
        <BigSpinner />
      </OuterDiv>
    </Dialog>
  )
}

export default SpinnerDialog
